/**
 * Session app — /apps/session/*
 *
 * One job: a group weighs in on a set of options together and leaves with a
 * defensible result. Four screens (C Mode maximum):
 *   /                 My sessions (participant + facilitator entry)
 *   /new              Facilitator setup — configure + invite (the "bonus section")
 *   /:sessionId/host  Facilitator console — open, watch, close, publish
 *   /:sessionId       Participant mode — the existing responsive session flow
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import MySessionsScreen from './MySessionsScreen';
import NewSessionScreen from './NewSessionScreen';
import HostScreen from './HostScreen';
import JoinScreen from './JoinScreen';

export default function SessionApp() {
  const app = getAppDefinition('session')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<MySessionsScreen />} />
        <Route path="new" element={<NewSessionScreen />} />
        <Route path=":sessionId/host" element={<HostScreen />} />
        <Route path=":sessionId" element={<JoinScreen />} />
        <Route path="*" element={<Navigate to="/apps/session" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
